import classNames from 'classnames';
import { useMemo } from 'react';
import { Figure, Flex } from 'yoso';
import lockImage from '~/components/Icon/lock.png';
import { levelMetaMap } from '~/components/Level/Level.hooks';
import { useCitizensByLevel } from '~/components/Membership/Membership.hooks';
import styles from './CitizenLevelStatusFigure.module.scss';

export interface CitizenLevelStatusFigureProps {
  level: number;
  className?: string;
  lock?: boolean;
}
export const CitizenLevelStatusFigure = ({
  level,
  className,
  lock,
}: CitizenLevelStatusFigureProps) => {
  const { placeholderImage } = levelMetaMap[level];
  const { data: citizens } = useCitizensByLevel(level);
  const isLocked = typeof lock === 'boolean' ? lock : citizens.length === 0;
  const defaultImage = useMemo(
    () => (isLocked ? lockImage : citizens[0]?.contentsUrl || placeholderImage),
    [isLocked, citizens, placeholderImage]
  );

  return (
    <Flex
      container
      alignItems="center"
      justifyContent="center"
      className={classNames(
        styles.root,
        { [styles.locked]: isLocked, [`citizen-level-${level}`]: level },
        className
      )}>
      <Figure src={defaultImage} />
    </Flex>
  );
};
